import type { Event } from '@patsnap/tahiti-core/common/event';
import type { AIDisclosureState } from '../types';

export const AIDisclosureService = Symbol('AIDisclosureService');

export interface AIDisclosureService {
    getModelData: () => AIDisclosureState;
    readonly onStatesChange: Event<AIDisclosureState>;
    updateInput: (input: string) => void;
    goResult: () => void;
    startGenerate: (taskId: string) => Promise<boolean>;
    putTechMeans: (techMeans: string) => void;
    init: (taskId: string) => void;
}
